const facilities = [
  {
    name: "Great Falls Main Post Office",
    address: "215 1st Ave N, Great Falls, MT 59401",
    phone: "(406) 452-2801",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Primary acceptance facility for Cascade County passport applications",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Great Falls West Station",
    address: "1013 Central Ave W, Great Falls, MT 59404",
    phone: "(406) 453-5478",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Convenient west side Great Falls location",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Cascade County Clerk",
    address: "415 2nd Ave N, Great Falls, MT 59401",
    phone: "(406) 454-6780",
    hours: "Mon–Fri 8:00am–5:00pm",
    note: "County vital records and passport acceptance services",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Malmstrom AFB Legal Office",
    address: "7200 Perimeter Rd, Malmstrom AFB, MT 59402",
    phone: "(406) 731-4400",
    hours: "Mon–Fri 8:00am–4:30pm",
    note: "Serving active duty, dependents, and eligible civilians",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Conrad Post Office",
    address: "18 S Virginia St, Conrad, MT 59425",
    phone: "(406) 278-3482",
    hours: "Mon–Fri 8:30am–4:30pm",
    note: "Serves Pondera County and northern Golden Triangle communities",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Lewistown Post Office",
    address: "109 4th Ave N, Lewistown, MT 59457",
    phone: "(406) 538-8710",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Central Montana alternative for Fergus County residents",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Great Falls
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and children under 16 must apply in person at an acceptance facility. Here are the nearest locations serving Great Falls and Cascade County.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-government-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm leading-snug">{f.name}</h3>
                </div>
              </div>
              <div className="space-y-2 flex-1">
                <div className="flex items-start gap-2 text-sm text-gray-500">
                  <i className="ri-map-pin-line text-gray-400 flex-shrink-0 mt-0.5"></i>
                  <span>{f.address}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-phone-line text-gray-400 flex-shrink-0"></i>
                  <span>{f.phone}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                  >
                    Visit website
                  </a>
                </div>
              </div>
              {f.note && (
                <p className="mt-3 pt-3 border-t border-gray-100 text-xs text-gray-400 italic">{f.note}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#EEF2F8] rounded-lg p-6 flex items-start gap-4">
          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
            <i className="ri-lightbulb-line text-[#F6C344] text-xl"></i>
          </div>
          <div>
            <p className="font-semibold text-[#1A365D] text-sm mb-1">Already Have Your Documents?</p>
            <p className="text-gray-500 text-sm leading-relaxed">
              If you&apos;re renewing an adult passport and have all paperwork ready, you do <strong>not</strong> need to visit an acceptance facility. Fast Passport Center handles the entire process by mail — including the agency submission.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}